import { useGSAP } from '@/hooks/useGSAP';
import Lenis from 'lenis';
import React, { useEffect } from 'react';

import Automation from '@/components/landing/common/Automation';
import Features from '@/components/landing/common/Features';
import GettingStarted from '@/components/landing/common/GettingStarted';
import Hero from '@/components/landing/home/Hero';
import RiskReward from '@/components/landing/home/RiskReward';
import SelfService from '@/components/landing/home/SelfService';
import SuccessStudy from '@/components/landing/home/SuccessStudy';
import TrustedBy from '@/components/landing/common/TrustedBy';
import Footer from '@/components/landing/layout/Footer';
import Header from '@/components/landing/layout/Header';
import InsurancePartners from '@/components/landing/common/InsurancePartners';
import ProtegaOffers from '@/components/landing/home/ProtegaOffers';



const HomePage: React.FC = () => {
  useEffect(() => {
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
  }

  const lenis = new Lenis({
    duration: 1.6,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    orientation: 'vertical',
    smoothWheel: true,
    touchMultiplier: 2,
  });

  function raf(time: number) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }

  requestAnimationFrame(raf);

  const handleBeforeUnload = () => {
    sessionStorage.setItem('scrollY', String(window.scrollY));
  };
  window.addEventListener('beforeunload', handleBeforeUnload);

  // 👇 Check if it's a reload (type === 'reload')
  const navEntries = performance.getEntriesByType('navigation') as PerformanceNavigationTiming[];
  const isReload = navEntries.length > 0 && navEntries[0].type === 'reload';

  if (isReload) {
    const savedScrollY = sessionStorage.getItem('scrollY');
    if (savedScrollY !== null) {
      setTimeout(() => {
        window.scrollTo(0, parseFloat(savedScrollY));
      }, 100); // Wait for Lenis and DOM layout
    }
  }

  return () => {
    lenis.destroy();
    window.removeEventListener('beforeunload', handleBeforeUnload);
  };
}, []);

  useGSAP();

  return (
  <div className="tw-min-h-screen tw-bg-black tw-text-white">
    <Header />

    <main className="tw-relative">
      <Hero />

      <section className="tw-mt-12 tw-mb-12 sm:tw-mt-16 sm:tw-mb-16 md:tw-mt-24 md:tw-mb-24">
        <TrustedBy />
      </section>
      

      <section className="tw-mt-12 tw-mb-12 sm:tw-mt-16 sm:tw-mb-16 md:tw-mt-24 md:tw-mb-24">
        <Features />
      </section>

      <ProtegaOffers />

      <section className="tw-mt-12 tw-mb-12 sm:tw-mt-16 sm:tw-mb-16 md:tw-mt-24 md:tw-mb-24">
        <InsurancePartners />
      </section>


      <section className="tw-mt-12 tw-mb-12 sm:tw-mt-16 sm:tw-mb-16 md:tw-mt-24 md:tw-mb-24">
        <Automation />
      </section>

      <section className="tw-mt-12 tw-mb-12 sm:tw-mt-16 sm:tw-mb-16 md:tw-mt-24 md:tw-mb-24">
        <SelfService />
      </section>

      <section className="tw-mt-12 tw-mb-12 sm:tw-mt-16 sm:tw-mb-16 md:tw-mt-24 md:tw-mb-24">
        <RiskReward />
      </section>

      <section className="tw-mt-12 tw-mb-12 sm:tw-mt-16 sm:tw-mb-16 md:tw-mt-24 md:tw-mb-24">
        <SuccessStudy />
      </section>

      <section className="tw-mt-12 tw-mb-12 sm:tw-mt-16 sm:tw-mb-16 md:tw-mt-24 md:tw-mb-24">
        <GettingStarted/>
      </section>
      <Footer />
    </main>
  </div>
);
};

export default HomePage;
